<div class="p-fluid">
  <!-- Loading State -->
  @if (loading && !error) {
    <div class="pageLoader">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }

  <!-- Error State -->
  @if (error) {
    <p-message severity="error" [text]="error" styleClass="p-mb-3">
      <ng-template pTemplate="closeicon">
        <button type="button" class="p-message-close p-link" (click)="error = null">
          <span class="p-message-close-icon pi pi-times"></span>
        </button>
      </ng-template>
    </p-message>
  }

  <!-- Content -->
  @if (!loading && !error) {
    <div>
      <div class="dual-list-container">
        <!-- Available Charts -->
        <div class="list-panel">
          <div class="list-header">
            <i class="pi pi-list" style="margin-right: 8px;"></i>
            <span>Available Charts ({{sourceItems.length}})</span>
          </div>
          <input type="text"
            pInputText
            [(ngModel)]="sourceFilter"
            placeholder="Search charts..."
            class="filter-input" />
          <div class="list-content">
            @for (item of getFilteredSource(); track item) {
              <div
                class="list-item"
                [class.selected]="isSourceSelected(item)"
                (click)="toggleSourceSelection(item)">
                <i [class]="item.icon" style="margin-right: 8px;"></i>
                <span>{{item.label}}</span>
              </div>
            }
            @if (getFilteredSource().length === 0) {
              <div class="empty-message">
                No charts available
              </div>
            }
          </div>
        </div>
        <!-- Transfer Buttons -->
        <div class="transfer-buttons">
          <button pButton
            type="button"
            icon="pi pi-angle-right"
            (click)="moveToTarget()"
            [disabled]="selectedSourceItems.length === 0"
          class="p-button-sm"></button>
          <button pButton
            type="button"
            icon="pi pi-angle-double-right"
            (click)="moveAllToTarget()"
            [disabled]="sourceItems.length === 0"
          class="p-button-sm"></button>
          <button pButton
            type="button"
            icon="pi pi-angle-left"
            (click)="moveToSource()"
            [disabled]="selectedTargetItems.length === 0"
          class="p-button-sm"></button>
          <button pButton
            type="button"
            icon="pi pi-angle-double-left"
            (click)="moveAllToSource()"
            [disabled]="targetItems.length === 0"
          class="p-button-sm"></button>
        </div>
        <!-- Selected Charts -->
        <div class="list-panel">
          <div class="list-header">
            <i class="pi pi-check-circle" style="margin-right: 8px;"></i>
            <span>Assigned Charts ({{targetItems.length}})</span>
          </div>
          <input type="text"
            pInputText
            [(ngModel)]="targetFilter"
            placeholder="Search charts..."
            class="filter-input" />
          <div class="list-content">
            @for (item of getFilteredTarget(); track item) {
              <div
                class="list-item"
                [class.selected]="isTargetSelected(item)"
                (click)="toggleTargetSelection(item)">
                <i [class]="item.icon" style="margin-right: 8px;"></i>
                <span>{{item.label}}</span>
              </div>
            }
            @if (getFilteredTarget().length === 0) {
              <div class="empty-message">
                No charts assigned
              </div>
            }
          </div>
        </div>
      </div>
      <div class="save-button-container">
        @if (savedSuccessfully) {
          <p-message severity="success" text="Chart selections saved successfully!" styleClass="p-mr-3"></p-message>
        }
        <button pButton
          type="button"
          label="Save Changes"
          icon="pi"
          [icon]="saving ? 'pi pi-spin pi-spinner' : 'pi-save'"
          class="p-button-primary"
          [disabled]="saving"
          (click)="onSave()">
        </button>
      </div>
    </div>
  }
</div>